import { z } from "zod";
import { ServiceType } from "../enums/ServiceType.js";
/**
 * Runtime validation schema for the `POST /quotation` request body. Mirrors
 * exactly what the FE `quotationRequestService.buildQuotationRequest` /
 * `serviceFreezer` produce — and ONLY that. Applied via `ZodValidationPipe`
 * on the controller, it strips any extra key the client might inject
 * (`id`, `quotation`, audit fields…), which closes a mass-assignment / IDOR:
 * a forged line carrying an `id` would otherwise be copied straight into the
 * persisted entity and TypeORM's `save` would UPDATE that existing row.
 *
 * Unknown keys are stripped (Zod's default), not rejected, so a benign extra
 * field never breaks a quotation; only the allowlisted fields reach the service.
 *
 * No `shiftings`: travel fees are recomputed server-side from the persisted
 * events since #535 (the FE payload was ignored), so the request carries only
 * the service lines. The recompute is the single source of truth (#532 PR4).
 */
const QuotationRequestServiceSchema = z.object({
    date: z.string(),
    label: z.string(),
    quantity: z.number(),
    unitPrice: z.number(),
    price: z.number(),
    discountLabel: z.string().nullable(),
    type: z.nativeEnum(ServiceType),
    account: z.number().nullable(),
    index: z.number(),
    descriptionId: z.string(),
    vatRate: z.number().nullable().optional(),
});
export const QuotationRequestPayloadSchema = z.object({
    date: z.string(),
    deadlineToAccept: z.string(),
    eventIds: z.array(z.string()),
    customerId: z.string(),
    services: z.array(QuotationRequestServiceSchema),
});
export const SendQuotationPayloadSchema = z.object({ fileName: z.string() });
//# sourceMappingURL=quotation.model.js.map